/* eslint-disable no-unused-vars */
import "./internationalization/i18n";
import "./mocks";

import { Helmet, HelmetProvider } from "react-helmet-async";

import AdapterDateFns from "@mui/lab/AdapterDateFns";

import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import QueryClientProvider from "./components/util/QueryClientProvider";
import React, { useEffect } from "react";
import { StyledEngineProvider } from "@mui/styled-engine-sc";
import StylesProvider from "@mui/styles/StylesProvider";
import { create } from "jss";
import createTheme from "./theme";
import { el } from "date-fns/locale";
import jssPreset from "@mui/styles/jssPreset";
import routes from "./routes/routes";
import { useRoutes } from "react-router-dom";
import useTheme from "./hooks/useTheme";
import LoginTabProvider from "./contexts/LoginTabContext";
import useAuth from "./hooks/useAuth";
import { getCaptchaKey } from "./services/captchaService";
import { keySiteAtom } from "./atom/atoms";
import { useAtom } from "jotai";

const jss = create({
  ...jssPreset(),
  insertionPoint: document.getElementById("jss-insertion-point"),
});

function App() {
  const content = useRoutes(routes);
  const [{ setAuthState }] = useAuth();
  const { theme } = useTheme();
  const [, setKeySite] = useAtom(keySiteAtom);

  const fetchKey = async () => {
    try {
      const res = await getCaptchaKey();
      setKeySite(res?.data);
    } catch (error) {
      setKeySite(null);
    }
  };

  useEffect(() => {
    if (window?.sessionStorage?.getItem("user")) {
      try {
        const user = JSON?.parse(window?.sessionStorage?.getItem("user"));
        const publisher = JSON.parse(
          window?.sessionStorage?.getItem("publisher")
        );
        const routes = JSON.parse(window?.sessionStorage?.getItem("routes"));
        setAuthState(user, publisher, routes, true);
      } catch (error) {
        console.error(error);
      }
    }
    fetchKey();
  }, []);

  return (
    <HelmetProvider>
      <Helmet titleTemplate="%s" defaultTitle="Digibook4All" />
      <StylesProvider jss={jss}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <StyledEngineProvider injectFirst>
            <MuiThemeProvider theme={createTheme(theme)}>
              <QueryClientProvider>
                <LoginTabProvider>{content}</LoginTabProvider>
              </QueryClientProvider>
            </MuiThemeProvider>
          </StyledEngineProvider>
        </LocalizationProvider>
      </StylesProvider>
    </HelmetProvider>
  );
}

export default App;
